'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdGridOff = function MdGridOff(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.6 33.4h2.5l-2.5-2.5v2.5z m-3.2 0v-5.8l-1-1h-5.8v6.8h6.8z m-10-10v-5.8l-1-1h-5.8v6.8h6.8z m0 10v-6.8h-6.8v6.8h6.8z m-6.8-22.5v2.5h2.5z m10 10v2.5h2.5z m-14.5-18.8l35.8 35.8-2.1 2.1-3.4-3.4h-25.8c-1.8 0-3.2-1.4-3.2-3.2v-25.8l-3.4-3.4z m24.5 4.5v6.8h6.8v-6.8h-6.8z m-13.2 0h-2.5l-3.3-3.2h25.8c1.8 0 3.2 1.4 3.2 3.2v25.8l-3.2-3.3v-2.5h-2.5l-3.3-3.2h5.8v-6.8h-6.8v5.8l-3.2-3.3v-2.5h-2.5l-3.3-3.2h5.8v-6.8h-6.8v5.8l-3.2-3.3v-2.5z' })
        )
    );
};

exports.default = MdGridOff;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/grid-off.js
// module id = 1590
// module chunks = 168707334958949